import styled from 'styled-components';
import { LAYOUT } from '@/constants/styles';
import { getFontStyles } from '@/redux/cmsConfig/utils';

export const StyledFavoritesFlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: ${LAYOUT.GUTTER}px;

  h2 {
    width: 100%;
  }
`;

export const StyledInlineContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    margin: 0;

    button {
      width: 100%;
    }

    > :first-child {
      margin: ${LAYOUT.GUTTER}px 0 0 0;
    }
  }
`;

export const StyledFavoriteCard = styled.div(({ theme }) => ({
  background: theme.location_card.background_color ?? 'inherit',
  border: `solid 1px ${theme.location_card.border_color ?? 'transparent'}`,
  borderRadius: `${theme.location_card.border_radius ?? 0}px`,
  marginBottom: '20px',
  padding: '20px',
  width: 'calc(50% - 10px)',
  ...getFontStyles(theme.location_card.font, ['font_size']),

  '@media (max-width: 767px)': {
    width: '100%',
  },

  h3: {
    margin: 0,
    ...getFontStyles(
      theme.location_card.secondary_font,
      ['font_family', 'font_size', 'font_style', 'color', 'line_height'],
      {
        font_size: (value) => (typeof value === 'number' ? value : 16),
        line_height: (value) => (typeof value === 'number' ? value : 20),
      },
    ),
  },

  a: {
    fontFamily: theme.primary_font.bold.font_family,
    fontSize: '16px',
    color: theme.global.primary_active_color,
    textDecoration: 'underline',
    transition: 'opacity 0.2s linear',

    '&:hover': {
      opacity: 0.7,
    },
  },
}));

export const StyledBasketItemContainer = styled.div`
  min-height: 64px;
`;

export const StyledDate = styled.p`
  margin: 0 auto ${LAYOUT.GUTTER}px 0;
`;

export const StyledTitleAndHeartIconContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    height: 25px;
  }
`;

export const StyledOrderTotal = styled.p`
  font-size: 16px;
  margin: 0;
`;

export const StyledNoDataContainer = styled.div`
  ${({ theme }) => `
    background: ${theme.auth_page.background_color};
    border: solid 1px ${theme.auth_page.border_color};
    border-radius: ${theme.auth_page.border_radius}px;
  `}

  width: 100%;

  @media (max-width: 767px) {
    min-width: 0;
    width: 100%;
  }
`;

export const StyledNoDataContent = styled.div(({ theme }) => ({
  margin: '0 auto',

  padding: '40px',
  textAlign: 'center',

  h3: {
    ...getFontStyles(theme.auth_page.secondary_font, [
      'color',
      'font_family',
      'font_weight',
      'font_style',
      'line_height',
    ]),
  },
  p: { ...getFontStyles(theme.auth_page.font) },

  img: { height: '25px' },

  '@media (max-width: 767px)': {
    maxWidth: '100%',
  },
}));
